let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fsreA")).then(() => parcelRequire('9YdD8'));